module.exports = __webpack_public_path__ + "img/vale.4a92dd5a.svg";